import Modal from './Modal.vue'
import ActionModal from './ActionModal'

export default Modal

export {
  ActionModal
}



// WEBPACK FOOTER //
// ./src/app/components/common/modal/index.js